import React, { Component } from "react";
import Card from "../components/Card";

export default class Previouswork extends Component {
  render() {
    return (
      <React.Fragment>
        <Card className="content" headerText="Previous Projects">
          <p>
            The following projects were built in my own time, either as
            freelance work, creative experiments, or ways to sharpen my skills
            with different platforms and tools. Each one reflects a hands-on
            approach to solving real design and development challenges.
          </p>
        </Card>

        <Card
          className="content"
          headerText="Dapper Creative – Custom Wedding Invitation Website"
        >
          <p>
            <i>Built on Shopify</i>
          </p>
          <p>
            This project was for a boutique wedding stationery brand that needed
            a Shopify store tailored to selling personalised invitations. The
            key requirement was allowing customers to enter their own wedding
            details: names, dates, venue info, etc. directly on the product
            page. I customised the theme to support this using Shopify’s line
            item properties, adding clean, intuitive input fields that fed
            seamlessly into the checkout process. This way, all the necessary
            details were captured with each order without complicating the user
            experience. The end result was a sleek, user-friendly site that made
            it easy for couples to order fully personalized invitations, while
            keeping everything manageable for the client on the back end.
          </p>
        </Card>

        <Card
          className="content"
          headerText="The Legal Startup – Blog Website for Aspiring Lawyers"
        >
          <p>
            <i>Built with WordPress & Elementor</i>
          </p>
          <p>
            The Legal Startup is a content driven website designed for aspiring
            and early career lawyers. The goal was to create a clean, engaging
            platform where users could stay updated on modern legal trends,
            industry news, and practical career advice. I developed the site
            using WordPress with Elementor to ensure full design flexibility and
            easy content management for the client. The layout prioritises
            readability and organization, with structured categories and an
            intuitive UI to support regular blog updates..
          </p>
        </Card>

        <Card
          className="content"
          headerText="Separate Collection – Shopify Store for a Clothing Brand"
        >
          <p>
            <i>Built with Shopify | Custom Collections Setup</i>
          </p>
          <p>
            This project involved building a clean, user-friendly Shopify store
            for a streetwear clothing brand. Using Shopify’s built-in
            Collections and Automated Tag Logic, I created a structure that made
            it easy for customers to browse by category, while also keeping
            things simple for the client to manage behind the scenes. I
            customized the navigation and product filtering to match the brand’s
            aesthetic and ensure a smooth shopping experience.
          </p>
        </Card>
      </React.Fragment>
    );
  }
}
